import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import "bootstrap/dist/css/bootstrap.css";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import "./App.css";
import { GlobalErrorModal } from "./components";
import { context } from "./context";
import { Router } from "./navigation/router";
import { AUTHENTICATION_INITIAL, AUTHENTICATION_UPDATE } from "./store/slices";
import { BusinessInstance } from "./utils/businessClass";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: context.userPoolId,
      userPoolClientId: context.userPoolClientId,
    },
  },
  Storage: {
    S3: {
      bucket: context.s3Bucket,
      region: context.s3BucketRegion,
    },
  },
});

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (token) {
      dispatch(
        AUTHENTICATION_UPDATE({
          data: {
            ...AUTHENTICATION_INITIAL,
            token,
          },
        }),
      );


    }
  }, [dispatch]);

  return (
    <div className="App" style={{ backgroundColor: "#eaeaea", minHeight: "100vh", height: "100%" }}>
      <Router />
      <GlobalErrorModal />
    </div>
  );
}

export default App;
